"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveTokens = resolveTokens;
exports.resolveScaffoldContext = resolveScaffoldContext;
/**
 * Resolve template tokens like {{a}}, {{b}}, {{answer}} in a string.
 * Unknown tokens are left untouched.
 */
function resolveTokens(str, ctx) {
    if (!str)
        return '';
    return str.replace(/\{\{(\w+)\}\}/g, (_match, key) => {
        const value = ctx?.[key];
        return value !== undefined ? String(value) : `{{${key}}}`;
    });
}
function resolveScaffoldContext(activity) {
    const config = activity.config || {};
    const ctx = {};
    switch (activity.type) {
        case 'maths': {
            const expression = String(config.expression || '');
            const parts = expression.match(/(\d+)\s*[-+×÷]\s*(\d+)/);
            if (parts) {
                ctx.a = Number(parts[1]);
                ctx.b = Number(parts[2]);
            }
            const expected = config.expectedAnswer;
            if (expected !== undefined)
                ctx.answer = Number(expected);
            break;
        }
        case 'spelling': {
            const word = String(config.word || '');
            ctx.a = word;
            ctx.answer = word;
            break;
        }
        case 'sentence_building':
        case 'copy_writing': {
            ctx.answer = String(config.sentence || config.targetText || '');
            break;
        }
        case 'dictation': {
            ctx.answer = String(config.targetText || '');
            break;
        }
        case 'reading_comprehension': {
            ctx.answer = String(config.prompt || '');
            break;
        }
        case 'common_exception_words': {
            ctx.answer = String(config.word || '');
            break;
        }
        case 'letter_tracing':
        case 'independent_writing':
        case 'typed_composition': {
            ctx.answer = String(config.targetText || config.prompt || '');
            break;
        }
        default:
            break;
    }
    return ctx;
}
